export const FETCH_PLACES = 'FETCH_PLACES';
export const FETCH_PLACE = 'FETCH_PLACE';
export const FETCH_FLIGHTS = 'FETCH_FLIGHTS';
export const FETCH_TRIPS = 'FETCH_TRIPS';
export const TYPE_DATES = 'TYPE_DATES';
export const FETCH_DESTINIES = 'FETCH_DESTINIES';
export const FETCH_DESTINIES_OPTIONS_FROM_ORIGIN = 'FETCH_DESTINIES_OPTIONS_FROM_ORIGIN';
export const CHECK_TRIP = 'CHECK_TRIP';
